import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Footer from "./Footer";
import Header from "./Header";
import WebsiteDevelopmentIco4 from "./assets/img/WebsiteDevelopmentIco-4.png";
import seoIco1 from "./assets/img/seoIco-1.png";
import seoIco2 from "./assets/img/seoIco-2.png";
import seoIco3 from "./assets/img/seoIco-3.png";
import seoIco4 from "./assets/img/seoIco-4.png";
import seoIco5 from "./assets/img/seoIco-5.png";
import DedicatedTeamsImg3 from "./assets/img/DedicatedTeamsImg-3.png";
const SecurityTestingServices = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="topPageBanner">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Security Testing Services by Hummingtec</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="innerPageIntroData whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap text-center">
                  <h2>Uncover Vulnerabilities Before Hackers Do</h2>
                  <p>
                    In today’s rapidly evolving threat landscape, security is
                    not a feature—it’s a necessity. At{" "}
                    <strong>Hummingtec</strong>, we provide advanced{" "}
                    <strong>Security Testing Services</strong> that help you
                    identify and fix vulnerabilities across your applications,
                    networks, APIs, and infrastructure. Our expert-driven
                    approach simulates real-world attack scenarios to expose
                    weak spots before they’re exploited in the wild.
                  </p>
                  <p>
                    Whether you're developing software, running a digital
                    business, or managing IT infrastructure, our testing
                    services ensure your systems stay resilient, compliant, and
                    secure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fashionWrap aboutSectionWrap">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-5">
                <div className="dataWrap sticyDiv">
                  <h2>What We Offer</h2>
                  <p>
                    Our Security Testing services are designed to uncover flaws
                    across every layer of your digital environment. We focus on
                    identifying critical security issues such as authentication
                    flaws, injection attacks, insecure APIs, misconfigurations,
                    and data exposure.
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <div className="masonaryWrap">
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                  >
                    <Masonry>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco1} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Web Application Security Testing</h2>
                          <p>
                            We conduct manual and automated security testing of
                            web applications to identify:
                          </p>
                          <ul>
                            <li>SQL Injection, XSS, CSRF</li>
                            <li>Authentication and session management flaws</li>
                            <li>File upload vulnerabilities</li>
                            <li>
                              Insecure deserialization and business logic issues
                            </li>
                            <li>Security misconfigurations</li>
                          </ul>
                          <p>
                            We follow OWASP Top 10 and beyond to ensure robust
                            coverage.
                          </p>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco2} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Mobile Application Security Testing</h2>
                          <p>
                            Our mobile security testing covers Android and iOS
                            platforms and includes:
                          </p>
                          <ul>
                            <li>Static and dynamic analysis</li>
                            <li>Source code review (if available)</li>
                            <li>API and backend communication testing</li>
                            <li>
                              Data storage security (e.g., keychain, shared
                              prefs)
                            </li>
                            <li>Reverse engineering and obfuscation testing</li>
                          </ul>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img
                            src={WebsiteDevelopmentIco4}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>API Security Testing</h2>
                          <p>
                            Modern applications rely heavily on APIs, making
                            them a key attack surface. We test for:
                          </p>
                          <ul>
                            <li>Broken object-level authorization</li>
                            <li>Insecure endpoints</li>
                            <li>Excessive data exposure</li>
                            <li>Lack of rate limiting</li>
                            <li>JWT & OAuth flaws</li>
                          </ul>
                          <p>
                            We align our API testing with OWASP API Security Top
                            10.
                          </p>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco3} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Network & Infrastructure Security Testing</h2>
                          <p>
                            Our team performs internal and external network
                            penetration testing to simulate real-world attacks:
                          </p>
                          <ul>
                            <li>Port scanning and service enumeration</li>
                            <li>Firewall and IDS/IPS evasion</li>
                            <li>Exploiting unpatched services</li>
                            <li>Privilege escalation and lateral movement</li>
                            <li>
                              Cloud environment assessments (AWS, Azure, GCP)
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco4} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Configuration & Hardening Review</h2>
                          <p>
                            Misconfigured servers, storage buckets, or access
                            controls can expose critical data. We evaluate:
                          </p>
                          <ul>
                            <li>SSL/TLS configurations</li>
                            <li>Cloud bucket policies (S3, Blob)</li>
                            <li>Server banners and version disclosures</li>
                            <li>Default credentials and weak passwords</li>
                            <li>IAM roles and permission boundaries</li>
                          </ul>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco5} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Source Code Review (Secure Code Audit)</h2>
                          <p>
                            We review your source code to uncover logic flaws,
                            insecure coding practices, and backdoors that may
                            not be visible through black-box testing.{" "}
                          </p>
                          <p>
                            <strong>Languages we support :</strong> Python, PHP,
                            JavaScript, Node.js, .NET, and more.
                          </p>
                        </div>
                      </div>
                    </Masonry>
                  </ResponsiveMasonry>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={DedicatedTeamsImg3} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Deliverables</h2>
                  <p>
                    At the conclusion of our engagement, Hummingtec provides a
                    detailed <strong>Security Testing Report</strong>, which
                    includes:
                  </p>
                  <ul>
                    <li>
                      <strong>1. </strong> Executive Summary for leadership
                    </li>
                    <li>
                      <strong>2. </strong> Technical details with CVSS scores
                    </li>
                    <li>
                      <strong>3. </strong> Proof of Concept (PoC) scripts
                    </li>
                    <li>
                      <strong>4. </strong> Screenshots or exploitation steps
                    </li>
                    <li>
                      <strong>5. </strong> Prioritized remediation plan
                    </li>
                    <li>
                      <strong>6. </strong> Secure coding recommendations
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Why Choose Hummingtec for Security Testing?</h2>
                  <ul>
                    <li>
                      <strong>1. </strong> Manual + Automated Hybrid Approach
                    </li>
                    <li>
                      <strong>2. </strong> Deep Technical Expertise across
                      platforms
                    </li>
                    <li>
                      <strong>3. </strong> Industry Standards: OWASP, NIST, ISO,
                      PCI-DSS
                    </li>
                    <li>
                      <strong>4. </strong> Clear, Actionable Reporting
                    </li>
                    <li>
                      <strong>5. </strong> Confidential & Compliant Processes
                    </li>
                  </ul>
                  <p>
                    From startups to enterprises, we help businesses proactively
                    defend their digital assets and build user trust.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={DedicatedTeamsImg3} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Don't Wait for a Breach to Act</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Security incidents can cost you reputation, customers, and
                    compliance. Let <strong>Hummingtec</strong> uncover your
                    weak spots—before attackers do.
                  </p>
                  <p>
                    {" "}
                    <Link className="btn" to="/Contact">
                      Contact Us
                    </Link>{" "}
                    today to schedule your security assessment and get a free
                    initial consultation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default SecurityTestingServices;
